export function createAPIGatewayUrl(path: string) {
  switch (process.env.VUE_APP_API_ENDPOINT) {
    case "production":
      return (
        "https://szxe3c80f3.execute-api.ap-northeast-1.amazonaws.com/prod/" +
        path
      );
    default:
      return (
        "https://rhbblcuauf.execute-api.ap-northeast-1.amazonaws.com/dev/" +
        // sigtiaの方にするとhttps://demo-sigtia.iot.kyoto/で確認出来る様になります
        // "https://hfi9cjtxzg.execute-api.ap-northeast-1.amazonaws.com/sigtia/" +
        path
      );
  }
}
